<template>
  <div class="container">
    <notifications></notifications>
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <h3 class="text-4xl">Please verify your email</h3>
      <p class="text-lg mt-4">
        We have sent you a verification email. Please check your email inbox and verify your email before you can login.
      </p>
      <base-button type="success" class="mb-6" size="lg" block @click="handleSendVerification">
        Send Verification Email Again
      </base-button>
      <base-button type="primary" class="mb-3" size="lg" block @click="handleGoToLogin">
        Go to Login
      </base-button>
    </div>
  </div>
</template>

<script>
import { auth } from '@/util/firebase.js'
import { notifySuccess } from '@/util/defaultNotifications.js'

export default {
  methods: {
    handleGoToLogin() {
      this.$router.push('login')
    },
    async handleSendVerification() {
      try {
        await auth.currentUser.sendEmailVerification()
        notifySuccess('Verification email has been sent.')
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style></style>
